import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Card from 'common/components/card';
import CardContent from 'common/components/card-content';
import CardHeader from 'common/components/card-header';
import {formatDate} from 'common/formatters/date-formatter';
import {DateTimeFormat} from 'common/proxies/enum-proxy';
import {t} from 'common/utils/translation-util';
import Colors from 'common/constants/colors';
import {formatNumber} from 'common/formatters/number-formatter';
import SvgSymbol from 'common/components/svg-symbol';
import './index.scss';

export default class AssetProfileCard extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool,
    report: PropTypes.object,
  };

  static defaultProps = {
    connectDragSource: (x) => x,
    disableConfig: true,
    report: {},
  };

  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  getAttributes(attributes) {
    return attributes.map((attribute) => {
      let {value} = attribute;
      if (attribute.isDate && value) {
        const date = new Date(value);
        const timestamp = moment(date);
        value = formatDate(timestamp, DateTimeFormat.ISO_DATE);
      }
      return {
        ...attribute,
        value,
      };
    });
  }

  getCustomConfigOptions(appUrl) {
    return [
      <a
        href={appUrl}
        key={'AssetProfileCard-custom-config-option--appUrl'}
        rel={'noopener noreferrer'}
        target={'_blank'}>
        <SvgSymbol name={'export'} />
        {t('Open in Assets app')}
      </a>,
    ];
  }

  render() {
    const {meta} = this.props.report;
    const {
      backgroundColor,
      backgroundPosition,
      backgroundSize,
      cardHeightAsImage,
      customImageHeight,
      height,
      src,
    } = meta.image;

    const attributes = this.getAttributes(meta.attributes);
    const customConfigOptions = this.getCustomConfigOptions(meta.appUrl);
    return (
      <Card
        className={'AssetProfileCard Card--corner-menu'}
        loading={this.state.loading}>
        {this.props.connectDragSource(
          <div>
            {src ? (
              <div
                style={{
                  backgroundColor: backgroundColor || Colors.gray900,
                  backgroundImage: `url(${src})`,
                  backgroundPosition: `${backgroundPosition} center`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize,
                  borderRadius: '5px 5px 0 0',
                  height: cardHeightAsImage ? height : customImageHeight,
                  overflow: 'hidden',
                }}
              />
            ) : null}
            <CardHeader
              customConfigOptions={customConfigOptions}
              disableConfig={this.props.disableConfig}
              disableSeparatorLine={attributes.length === 0}
              priorityWarnings={this.props.report.priorityWarnings}
              reportId={this.props.report.id}
              title={meta.name}
              warnings={this.props.report.warnings}
            />
          </div>,
        )}

        <CardContent
          className={'AssetProfileCard--content'}
          errorMessage={t('No data to display.')}
          showError={false}>
          <table
            className={'AssetProfileCard--table'}
            style={{
              border: 'none',
            }}>
            <tbody>
              {attributes.map((datum, index) => (
                <tr key={`AssetProfileCard-${meta.name}-${index}`}>
                  <td className={'AssetProfileCard--column-left'}>
                    <div>{datum.label}</div>
                  </td>
                  <td className={'AssetProfileCard--column-right'}>
                    <div className={'AssetProfileCard--column-right--content'}>
                      {
                        // FIXME: Short term solution. Django does not provide
                        // any currency related information as part of the datum
                        // metadata.
                        datum.id === 'unitPrice'
                          ? formatNumber(datum.value, 'currency')
                          : datum.value || '\u2013'
                      }
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    );
  }
}
